<script>
  import { createEventDispatcher } from 'svelte';
  import { forEach, orderBy } from 'lodash-es';

  const dispatch = createEventDispatcher();

  const heightRatio = 0.7017546031254834;
  const margin = 4;
  let canvasEl;
  let initialRender = false;

  export let height = 100;
  export let items = [];
  export let isInfected = 0;

  $: width = Math.round(height * heightRatio);
  $: stageWidth = width - margin * 2;
  $: stageHeight = height - margin * 2;

  $: itemsWithPositions = items.map(d => {
    let [[x1, y1, x2, y2], count] = d;
    x1 = margin + x1 * stageWidth;
    x2 = margin + x2 * stageWidth;
    y1 = margin + y1 * stageHeight;
    y2 = margin + y2 * stageHeight;
    const color = count !== 0 ? '#F63335' : '#ddd';
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1, color: color };
  });

  $: pageColor = isInfected ? '#F63335' : '#999';

  $: if (canvasEl && !initialRender) {
    const ctx = canvasEl.getContext('2d');

    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    ctx.beginPath();
    ctx.strokeStyle = pageColor;
    if (isInfected) {
      ctx.lineWidth = 3;
      ctx.strokeRect(2, 2, canvasEl.width - 4, canvasEl.height - 4);
    } else {
      ctx.lineWidth = 1;
      ctx.strokeRect(0, 0, canvasEl.width, canvasEl.height);
    }
    ctx.closePath();

    forEach(itemsWithPositions, d => {
      ctx.beginPath();
      ctx.rect(d.x, d.y, d.w, d.h);
      ctx.fillStyle = d.color;
      ctx.fill();
      ctx.closePath();
    });
    initialRender = true;
  }
</script>

<style>
  .page {
    margin: 0 3px 3px 0;
    cursor: pointer;
  }
  .page.is-infected {
    background: #feeaea;
  }
</style>

<div
  class="page"
  class:is-infected={isInfected}
  on:mouseenter={() => {
    dispatch('mouseover');
  }}
  on:mouseleave={() => {
    dispatch('mouseout');
  }}>
  <canvas
    bind:this={canvasEl}
    {width}
    {height}
    style={`width:${width / 2}px; height:${height / 2}px`} />
</div>
